
import { Vue, Component } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DatabaseRepositoryInterface, MigrationBatchInterface } from '@/services/Database/interfaces';
import { ServerRepositoryInterface } from '@/services/Server/Interfaces';
import WebsiteRepositoryInterface from '@/services/Website/interfaces';
import { DataTableHeader } from 'vuetify';

@Component({
  mixins: [Themeable],
  inject: [
    'databaseRepository',
    'serverRepository',
    'websiteRepository',
  ],
})
export default class DatabaseMigrationBatch extends Vue {
  public loading = true;

  public batchId!: number;

  public databaseRepository!: DatabaseRepositoryInterface;

  public serverRepository!: ServerRepositoryInterface;

  public websiteRepository!: WebsiteRepositoryInterface;

  public websiteDomainsMap: { [key: number]: string } = {};

  public serverHostnamesMap: { [key: string]: string } = {};

  public batch!: MigrationBatchInterface;

  public taskHeaders: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Type', value: 'type' },
    { text: 'Source ID', value: 'sourceId' },
    { text: 'Target ID', value: 'targetId' },
    { text: 'Status', value: 'status' },
  ];

  public async created(): Promise<void> {
    await this.loadBatches();
    await this.loadMaps();
    this.loading = false;
  }

  public async loadBatches(): Promise<void> {
    if (!this.$route.params.id) {
      this.$errorDialog.show('Missing batch id');

      return;
    }

    this.batch = await this.databaseRepository.getMigrationBatchById(this.$route.params.id);
  }

  public async loadMaps(): Promise<void> {
    const serverIds: string[] = [];
    const websiteIds: number[] = [];

    if (!serverIds.includes(this.batch.sourceServer)) {
      serverIds.push(this.batch.sourceServer);
    }

    if (!serverIds.includes(this.batch.targetServer)) {
      serverIds.push(this.batch.targetServer);
    }

    if (!websiteIds.includes(this.batch.sourceWebsiteId)) {
      websiteIds.push(this.batch.sourceWebsiteId);
    }

    if (!websiteIds.includes(this.batch.targetWebsiteId)) {
      websiteIds.push(this.batch.targetWebsiteId);
    }

    const servers = await this.serverRepository.getServersByIds(serverIds);

    servers.forEach((server) => {
      this.serverHostnamesMap[server._id] = server.hostname;
    });

    const websites = await this.websiteRepository.getWebsitesByIds(websiteIds);

    websites.forEach((website) => {
      this.websiteDomainsMap[website.id] = website.domain;
    });
  }

  public async deleteBatch(): Promise<void> {
    try {
      await this.databaseRepository.deleteMigrationBatch(this.batch.id);

      await this.$successDialog.show('Batch Deleted Successfully.');

      await this.$router.push({ name: 'databases_migrations_list' })
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message ? e.response.data.message : e.message);
    }
  }
}
